import React from 'react';
import { LanguageProvider } from './components/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainStory } from './components/PainStory';
import { ProblemList } from './components/ProblemList';
import { Solution } from './components/Solution';
import { Experience } from './components/Experience';
import { Barbers } from './components/Barbers';
import { Services } from './components/Services';
import { AdditionalServices } from './components/AdditionalServices';
import { Banner } from './components/Banner';
import { Comparison } from './components/Comparison';
import { LateHours } from './components/LateHours';
import { KidsSection } from './components/KidsSection';
import { Testimonials } from './components/Testimonials';
import { TheQuestion } from './components/TheQuestion';
import { TheExperience } from './components/TheExperience';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-barber-black text-barber-text selection:bg-barber-gold selection:text-barber-black" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <PainStory data-id="element-5" />
          <ProblemList data-id="element-6" />
          <Solution data-id="element-7" />
          <Experience data-id="element-8" />
          <Barbers data-id="element-9" />
          <Services data-id="element-10" />
          <AdditionalServices data-id="element-11" />
          <Banner data-id="element-12" />
          <Comparison data-id="element-13" />
          <LateHours data-id="element-14" />
          <KidsSection data-id="element-15" />
          <Testimonials data-id="element-16" />
          <TheQuestion data-id="element-17" />
          <TheExperience data-id="element-18" />
          <FAQ data-id="element-19" />
          <FinalCTA data-id="element-20" />
        </main>
        <Footer data-id="element-21" />
      </div>
    </LanguageProvider>;
}